import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../../services/api'; // Ensure this points to your axios instance

function ForgotPassword() {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);
        setMessage(null);

        try {
            // POST to the backend view we created
            await api.post('/users/auth/password-reset/', { email });
            // Always show success message for security
            setMessage(t('forgot_password.success_message', 'If an account exists, a reset link has been sent.'));
        } catch (err) {
            setError(t('forgot_password.error', 'Something went wrong. Please try again.'));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-brand-dark text-white">
            <div className="p-8 bg-brand-dark rounded-lg shadow-md w-full max-w-md border border-gray-700 hover:border-brand-orange">
                <h2 className="text-2xl font-bold text-center mb-4">{t('forgot_password.title', 'Reset Password')}</h2>
                <p className="text-gray-400 text-center mb-6 text-sm">
                    {t('forgot_password.instruction', 'Enter your email to receive a reset link.')}
                </p>

                {message ? (
                    <div className="bg-green-900/50 border border-green-500 text-green-200 p-4 rounded mb-6 text-center">
                        {message}
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="mb-6">
                            <label className="block text-orange-400 font-light mb-1" htmlFor="email">
                                {t('login.form.email')}
                            </label>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-3 py-2 border rounded-md bg-brand-dark border-brand-orange focus:outline-none focus:ring-2 focus:ring-orange-500"
                            />
                        </div>
                        {error && <p className="text-red-500 text-center mb-4">{error}</p>}
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="w-full bg-orange-500 text-white py-2 rounded-md hover:bg-orange-600 transition-colors font-semibold disabled:opacity-50"
                        >
                            {isSubmitting ? t('Loading...') : t('forgot_password.send_link', 'Send Reset Link')}
                        </button>
                    </form>
                )}

                <div className="mt-6 text-center">
                    <Link to="/login" className="text-gray-400 hover:text-white text-sm">
                        ← {t('Back to Login')}
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
